"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationHandset = void 0;
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _reactRedux = require("react-redux");
var getSelectedColorInTree = function getSelectedColorInTree(selectedColor, colorVariants) {
  var _selectedColor$value, _selectedColor$value$;
  var colorValue = selectedColor === null || selectedColor === void 0 ? void 0 : (_selectedColor$value = selectedColor.value) === null || _selectedColor$value === void 0 ? void 0 : (_selectedColor$value$ = _selectedColor$value.find(function (c) {
    return c.isDefault == true;
  })) === null || _selectedColor$value$ === void 0 ? void 0 : _selectedColor$value$.value;
  var selectedColorInTree = colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.find(function (color) {
    return color.value.find(function (c) {
      return c.value == colorValue;
    });
  });
  return selectedColorInTree;
};
var transformColor = function transformColor(color) {
  var _color$value, _color$value$find;
  return {
    text: color === null || color === void 0 ? void 0 : (_color$value = color.value) === null || _color$value === void 0 ? void 0 : (_color$value$find = _color$value.find(function (c) {
      return c.isDefault == true;
    })) === null || _color$value$find === void 0 ? void 0 : _color$value$find.value.split('|')[1],
    value: color === null || color === void 0 ? void 0 : color.variantId,
    color: Array.isArray(color === null || color === void 0 ? void 0 : color.value) ? color === null || color === void 0 ? void 0 : color.value[0].value.split('|')[0] : color === null || color === void 0 ? void 0 : color.value.split('|')[0]
  };
};
var transformMemory = function transformMemory(memory) {
  var _memory$value, _memory$value2;
  return {
    text: (memory === null || memory === void 0 ? void 0 : (_memory$value = memory.value) === null || _memory$value === void 0 ? void 0 : _memory$value.value) + (memory === null || memory === void 0 ? void 0 : (_memory$value2 = memory.value) === null || _memory$value2 === void 0 ? void 0 : _memory$value2.unitOfMeasure),
    value: memory === null || memory === void 0 ? void 0 : memory.variantId
  };
};
var getHandsetFilters = function getHandsetFilters(handset) {
  var filterTree = handset.filterTree,
    selectedVariant = handset.selectedVariant;
  var selectedColor = selectedVariant.color;
  var selectedMemory = selectedVariant.memory;
  var colorVariants = filterTree;
  var selectedColorInTree = getSelectedColorInTree(selectedColor, colorVariants);
  var memoryVariants = selectedColorInTree === null || selectedColorInTree === void 0 ? void 0 : selectedColorInTree.variants;
  var selectedMemoryInTree = memoryVariants === null || memoryVariants === void 0 ? void 0 : memoryVariants.find(function (memory) {
    return memory.variantId === selectedMemory.variantId;
  });
  return {
    colorVariants: colorVariants.map(transformColor),
    memoryVariants: memoryVariants === null || memoryVariants === void 0 ? void 0 : memoryVariants.map(transformMemory),
    selectedColor: transformColor(selectedColorInTree),
    selectedMemory: transformMemory(selectedMemoryInTree)
  };
};
var useRecommendationHandset = function useRecommendationHandset(handset) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var filters = getHandsetFilters(handset);
  var onHandsetSelect = function onHandsetSelect(productId) {
    dispatch((0, _recommendationActions.updateSelectedHandset)(productId));
  };
  var onVariantSelect = function onVariantSelect(productId, variantId) {
    dispatch((0, _recommendationActions.updateSelectedVariant)(productId, variantId));
  };
  return {
    filters: filters,
    onHandsetSelect: onHandsetSelect,
    onVariantSelect: onVariantSelect
  };
};
exports.useRecommendationHandset = useRecommendationHandset;